import ApiService from "./ApiService"


export async function partnerBasicDetailSave(data) {
    return ApiService.fetchData({
        url: `partners/savebasicdetails`,
        method: 'post',
        data
    })
}
export async function partnerBasicDetailUpdate(data, id) {
    return ApiService.fetchData({
        url: `partners/${id}/updateBasicDetails`,
        method: 'put',
        data
    })
}


export async function apiGetPartnerTypes(params) {
    return ApiService.fetchData({
        url: `partnertypes`,
        method: 'get',
        // params
    })
}

export async function apiGetRoles(params) {
    return ApiService.fetchData({
        url: `partner/user/roles`,
        method: 'get',
        // params
    })
}

export async function apiGetValidateShortName(data) {
    return ApiService.fetchData({
        url: `partners/shortnmevalidation/${data}`,
        method: 'get',
    })
}


export async function apiGetPartners(query) {
    return ApiService.fetchData({
        url: `partners${query}`,
        method: 'get'
    })
}

export async function apiCropCycleList(query) {
    return ApiService.fetchData({
        url: `crop-connects`,
        method: 'get'
    })
}

export async function apiGetPartnerContractDetails(id) {
    return ApiService.fetchData({
        url: `partners/${id}/contractdetails`,
        method: 'get'
    })
}
